// Translations
import landing from '../views/landing/translations/tr'

// Translation: Error (Turkish)
export default Object.freeze({
	name: 'Hata',
	views: { landing }
})
